import { getLanguage } from '../../helpers/language'
import { valToPercent } from '../../helpers/value'

export const handleOwnershipAndGroupData = (data, ids) => {
  const locale = getLanguage()
  if (!data.length) return {}
  const ownershipAndGroupData = {}
  ids?.forEach((id) => {
    const orgItem = data.find((item) => item.organizationId === id)
    ownershipAndGroupData[id] = {
      orderNumber: null,
      organizationName: orgItem.organizationName,
      individual: valToPercent(orgItem.individual, locale),
      stateOwnedEnterprises: valToPercent(
        orgItem.stateOwnedEnterprises,
        locale,
      ),
      nonStateEnterprises: valToPercent(orgItem.nonStateEnterprises, locale),
      foreignDirectInvestedEnterprises: valToPercent(
        orgItem.foreignDirectInvestedEnterprises,
        locale,
      ),
      others: valToPercent(orgItem.others, locale),
      numberOfBranches: orgItem.numberOfBranches,
      numberOfSubsidiaries: orgItem.numberOfSubsidiaries,
      numberOfAssociatedCompanies: orgItem.numberOfAssociatedCompanies,
    }
  })
  return ownershipAndGroupData
}

// Financial Statement

export const handleFinancialStatementHeader = (data) => {
  const tableHeaderOrigin = [
    {
      title: '',
      colId: 'col1',
    },
  ]
  const dataTitle = data.map((item) => {
    return {
      title: item.organizationName,
      colId: `${item.organizationId}`,
    }
  })
  return [...tableHeaderOrigin, ...dataTitle]
}

export const handleFinancialStatementIds = (payload, tabName) => {
  if (!payload?.length) {
    return []
  }

  return payload[0]?.[tabName]?.map((item) => {
    return item.ratioCode
  })
}

export const handleTabData = (payload, groupColumns, ids, tabName) => {
  if (!payload?.length) {
    return {}
  }
  const tabData = {}
  const colData = groupColumns.slice(1)

  ids.forEach((id) => {
    const rowItem = payload[0][tabName].find((item) => item.ratioCode === id)
    tabData[id] = {
      col1: rowItem.ratioName,
      fieldStyle: rowItem.fieldStyle,
      childrenIds: findAllChildrenId(payload[0][tabName], id),
      parentId: rowItem.parentRatioCode,
    }
  })
  ids.forEach((id) => {
    colData.forEach((col) => {
      const idItem = payload.find(
        (item) => item.organizationId === Number(col.colId),
      )
      tabData[id][col.colId] = idItem[tabName].find((i) => i.ratioCode === id)
    })
  })

  return tabData
}

const findAllChildrenId = (data, parentId) => {
  const childrenIds = data
    ?.filter((id) => id.parentRatioCode === parentId)
    .map((item) => {
      const childOfChildIds = findAllChildrenId(data, item.ratioCode)
      return [item.ratioCode, ...childOfChildIds]
    })

  return childrenIds.flat(1)
}

// financial Analysis
export const handleAnalysisTreeList = (payload) => {
  if (!payload) return []

  const treeList = payload.map((item) => {
    return {
      label: item.groupName,
      isI18n: false,
      children: item?.ratioItems.map((child) => {
        return {
          label: child.ratioName,
          isI18n: false,
          data: child.companyItems,
          unit: child.unit,
          itemId: child.ratioCode,
        }
      }),
    }
  })

  return treeList
}

export const handleActiveItem = (payload, activeItem) => {
  const ratioItems = payload.map((item) => item.ratioItems).flat()
  const itemIds = ratioItems.map((item) => item.ratioCode)
  if (activeItem && itemIds.includes(activeItem)) return activeItem
  return payload?.[0].ratioItems[0].ratioCode
}

export const getActiveLabelById = (payload, activeItem) => {
  const ratioItems = payload.map((item) => item.ratioItems).flat()
  const foundItem = ratioItems.filter((item) => item.ratioCode === activeItem)
  return foundItem ? foundItem[0].ratioName : ''
}

export const handleDataFA = (payload, activeItem) => {
  const ratioItems = payload.map((item) => item.ratioItems).flat()
  const foundItem = ratioItems.find((item) => item.ratioCode === activeItem)
  return {
    data: foundItem
      ? foundItem.companyItems
      : payload?.[0].ratioItems[0].companyItems,
    unit: foundItem ? foundItem.unit : payload?.[0].ratioItems[0].unit,
  }
}

export const handleTableFAIds = (payload) => {
  if (!payload) return []

  return payload.map((item) => item.organizationId)
}

export const handleTableFAHeader = (payload) => {
  const tableHeaderOrigin = [
    {
      title: '',
      colId: 'col1',
    },
    {
      title: 'companyAnalysis.peerAnalysis.COMPANY_NAME',
      colId: 'organizationName',
      isI18n: true,
    },
  ]
  if (!payload || !payload?.length) return tableHeaderOrigin
  const dataTable = payload[0].values.map((item) => {
    return {
      title: item.realYear,
      colId: item.realYear,
      thStyle: { justifyContent: 'flex-end' },
      tdStyle: { textAlign: 'right' },
    }
  })

  return [
    ...tableHeaderOrigin,
    ...dataTable.sort((a, b) => (a.title > b.title ? 1 : -1)),
  ]
}

export const handleTableFAData = (payload, ids, header, unit) => {
  if (!payload?.length) {
    return {}
  }

  const tableData = {}
  const colData = header.slice(2)
  ids.forEach((id) => {
    const dataItem = payload.find((item) => item.organizationId === id)
    tableData[id] = {
      col1: id,
      organizationName: dataItem.organizationName,
    }
  })

  ids.forEach((id) => {
    const dataValues = payload.find((item) => item.organizationId === id).values
    colData.forEach((col) => {
      const itemValue = dataValues.find((item) => item.realYear === col.colId)
      tableData[id][col.colId] = { ...itemValue, unit: unit }
    })
  })
  return tableData
}

// Recommendation List
export const getDataTable = (payload, ids) => {
  if (!payload?.length) return {}
  const tableData = {}
  ids.forEach((id) => {
    tableData[id] = payload.find((item) => item.organizationId === id)
  })
  return tableData
}

// Score
export const handleTableScoreIds = (payload = []) => {
  return payload.map((item) => item.organizationId)
}

export const handleTableScoreHeader = ({ scores = [] }) => {
  const tableHeaderOrigin = [
    {
      title: '',
      colId: 'col1',
    },
    {
      title: 'companyAnalysis.peerAnalysis.COMPANY_NAME',
      colId: 'organizationName',
      isI18n: true,
    },
  ]

  const dataTable = scores.map(({ realYear }) => {
    return { title: realYear, colId: realYear }
  })

  return [
    ...tableHeaderOrigin,
    ...dataTable.sort((a, b) => (a.title > b.title ? 1 : -1)),
  ]
}

export const handleScoreDataTable = (
  payload = [],
  ids = [],
  header = [],
  name,
) => {
  if (!payload.length) {
    return {}
  }

  const tableData = {}
  const colData = header.slice(2)

  ids.forEach((id) => {
    const dataItem = payload.find((item) => item.organizationId === id)
    tableData[id] = {
      col1: id,
      organizationName: dataItem.organizationName,
    }
  })

  ids.forEach((id) => {
    const dataValues = payload.find((item) => item.organizationId === id).scores
    colData.forEach((col) => {
      const itemValue = dataValues.find((item) => item.realYear === col.colId)
      tableData[id][col.colId] = {
        value: itemValue?.[name],
        publicDate:
          name === 'creditRiskScore'
            ? itemValue?.creditRiskScorePublicDate
            : itemValue?.performanceScorePublicDate,
      }
    })
  })
  return tableData
}

export const convertChartData = (data) => {
  const dataReal = data.map((item, index) => {
    let obj = {}
    item.forEach((key) => {
      obj['label'] = key.label
      obj[`data${index}`] = key.data
    })

    return obj
  })

  return dataReal
}
